import { treat, treatArrayItem } from './treat'

const getset = (context = null, casts = {}) => {
    for (let key in casts) {
        const cast = casts[key]

        const getType = () => {
            if (typeof cast === 'function') return 'model'
            else if (typeof cast === 'object') return 'array'
            return typeof cast === 'string' ? cast : undefined
        }

        const getT = () => {
            if (getType() === 'model') return cast
            else if (getType() === 'array' && cast.length === 1) return cast[0]
            return undefined
        }

        Object.defineProperty(context, key, {
            get: () => {
                return context[`_${key}`]
            },
            set: value => {
                context[`_${key}`] = treat(value, getType(), getT())
                if (getType() !== 'array') return

                context[`_${key}`].push = (...args) => {
                    for (const i in args) {
                        args[i] = treatArrayItem(args[i], getT())
                    }

                    return Array.prototype.push.call(
                        context[`_${key}`],
                        ...args,
                    )
                }
            },
        })
    }
}

export default getset
